import { __awaiter } from 'tslib';

const ENDPOINT = 'DOWNLOADcontract';
function downloadContract(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.get(downloadContract.endpoint, params, customURL, customHeaders, isKoussa);
    });
}
downloadContract.endpoint = ENDPOINT;

export { downloadContract as default };
//# sourceMappingURL=downloadContract.js.map
